module.exports = __webpack_public_path__ + "static/img/customize_en.c8a71ade.jpg";